// extracted by mini-css-extract-plugin
export default {"container":"EmailPeriod_container__OjC2J","icon":"EmailPeriod_icon__fhYV7"};